const globalState = {
  linkRules: [],
  cardLoader: null,
  smartdownScripts: [],
  smartdownScriptsMap: {},
  calcHandlers: null,
  twitterLoading: false,
  currentHomeDiv: null,
  currentMD: null,
  cardLoading: false,
  es6Playables: {},
  expressionsRegistered: {},
  playablesRegistered: {},
  playablesRegisteredOrder: [],
};

export default globalState;
